
import { defineComponent } from "vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default /*#__PURE__*/ defineComponent({
  name: "CarouselComponent",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  props: {
    slides: {
      type: Object,
      default: function () {
        return {};
      },
    },
    autoplay: {
      type: Number,
      default: 0,
    },
    infinite: {
      type: Boolean,
      default: false,
    },
  },
});
